import script from "./Enunciado.vue?vue&type=script&setup=true&lang=js"
export * from "./Enunciado.vue?vue&type=script&setup=true&lang=js"

import "./Enunciado.vue?vue&type=style&index=0&id=705bb161&lang=scss"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QPageSticky});
